import React, { FC } from 'react';
import Form from 'components/Form';

import { DurexPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Durex: FC<DurexPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Durex;
